import { render } from "./ResourcesHelp.vue?vue&type=template&id=4225e23a&scoped=true&lang=pug"
import script from "./ResourcesHelp.vue?vue&type=script&lang=js"
export * from "./ResourcesHelp.vue?vue&type=script&lang=js"

import "./ResourcesHelp.vue?vue&type=style&index=0&id=4225e23a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4225e23a"]])

export default __exports__